import React, { useState, useEffect } from 'react';
import { apiFetch } from '../../hooks/useApi';

const METADADOS = {
  ocr_activo: {
    label:  'OCR automático na foto de posse',
    tipo:   'toggle',
    grupo:  'Verificação de Posse',
    aviso:  'Desactivar significa revisão manual de todas as fotos.',
  },
  posse_threshold_usd: {
    label: 'Valor mínimo para foto obrigatória (USD/dia)',
    tipo:  'numero',
    grupo: 'Verificação de Posse',
  },
  fornecedor_conf_pede_posse: {
    label: 'Exigir foto de posse a fornecedores verificados',
    tipo:  'toggle',
    grupo: 'Fornecedores Verificados',
  },
  score_min_fornecedor_conf: {
    label: 'Score mínimo para fornecedor verificado',
    tipo:  'numero',
    grupo: 'Fornecedores Verificados',
  },
  upload_massa_activo: {
    label: 'Publicação em massa (bulk upload)',
    tipo:  'toggle',
    grupo: 'Bulk Upload',
  },
  upload_massa_max_produtos: {
    label: 'Máximo de produtos por bulk upload',
    tipo:  'numero',
    grupo: 'Bulk Upload',
  },
  upload_massa_score_min: {
    label: 'Score mínimo para bulk upload',
    tipo:  'numero',
    grupo: 'Bulk Upload',
  },
};

export default function Configuracoes() {
  const [settings, setSettings] = useState([]);
  const [salvando, setSalvando] = useState(null);
  const [guardado, setGuardado] = useState(null);
  const [loading,  setLoading]  = useState(true);
  const [erro,     setErro]     = useState('');

  useEffect(() => {
    apiFetch('/admin/configuracoes')
      .then(d => { if (d.sucesso) setSettings(d.configuracoes); })
      .catch(e => setErro(e.message))
      .finally(() => setLoading(false));
  }, []);

  const actualizar = async (chave, novoValor) => {
    setSalvando(chave);
    try {
      await apiFetch(`/admin/configuracoes/${chave}`, 'PUT', { valor: novoValor });
      setSettings(prev => prev.map(s => s.chave === chave ? { ...s, valor: novoValor } : s));
      setGuardado(chave);
      setTimeout(() => setGuardado(null), 2000);
    } catch (e) {
      setErro(e.message);
    }
    setSalvando(null);
  };

  // Agrupar por grupo
  const grupos = settings.reduce((acc, s) => {
    const m = METADADOS[s.chave];
    if (!m) return acc;
    if (!acc[m.grupo]) acc[m.grupo] = [];
    acc[m.grupo].push(s);
    return acc;
  }, {});

  if (loading) return (
    <div style={{ padding: '32px', color: 'var(--text-secondary)', fontSize: '14px' }}>
      A carregar configurações...
    </div>
  );

  return (
    <div style={{ maxWidth: '680px', margin: '0 auto', padding: '24px 16px' }}>
      <div style={{ marginBottom: '28px' }}>
        <h1 style={{ fontSize: '22px', fontWeight: '700', color: 'var(--text-primary)', margin: 0 }}>
          Configurações da plataforma
        </h1>
        <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginTop: '4px' }}>
          As alterações têm efeito imediato em toda a plataforma.
        </p>
      </div>

      {erro && (
        <div style={{ background: 'var(--danger-bg)', border: '1px solid var(--danger-border)',
          borderRadius: '12px', padding: '12px 16px', marginBottom: '20px',
          color: 'var(--danger)', fontSize: '13px' }}>
          {erro}
        </div>
      )}

      {Object.entries(grupos).map(([nomeGrupo, itens]) => (
        <div key={nomeGrupo} style={{ marginBottom: '28px' }}>
          <p style={{ fontSize: '11px', fontWeight: '700', color: 'var(--text-secondary)',
            textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '10px' }}>
            {nomeGrupo}
          </p>
          <div style={{ background: 'var(--card)', border: '1px solid var(--border)',
            borderRadius: '16px', overflow: 'hidden' }}>
            {itens.map((s, i) => {
              const m        = METADADOS[s.chave];
              const eSalvando = salvando === s.chave;
              const eGuardado = guardado === s.chave;
              const valor     = s.valor;

              return (
                <div key={s.chave} style={{
                  display: 'flex', alignItems: 'flex-start', gap: '16px',
                  padding: '16px',
                  borderTop: i > 0 ? '1px solid var(--border)' : 'none',
                }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{ fontSize: '14px', fontWeight: '600', color: 'var(--text-primary)', margin: 0 }}>
                      {m.label}
                    </p>
                    <p style={{ fontSize: '12px', color: 'var(--text-secondary)', marginTop: '2px' }}>
                      {s.descricao}
                    </p>
                    {m.aviso && (
                      <p style={{ fontSize: '12px', color: '#d97706', marginTop: '4px' }}>
                        ⚠ {m.aviso}
                      </p>
                    )}
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
                    {eGuardado && (
                      <span style={{ fontSize: '12px', color: 'var(--success)', fontWeight: '600' }}>
                        Guardado ✓
                      </span>
                    )}

                    {m.tipo === 'toggle' ? (
                      <button
                        onClick={() => actualizar(s.chave, !valor)}
                        disabled={eSalvando}
                        style={{
                          position: 'relative', width: '44px', height: '24px',
                          borderRadius: '9999px', border: 'none', cursor: 'pointer',
                          background: valor ? 'var(--success)' : 'var(--border)',
                          transition: 'background .2s', opacity: eSalvando ? 0.5 : 1,
                        }}
                        aria-label={`${valor ? 'Desactivar' : 'Activar'} ${m.label}`}
                      >
                        <span style={{
                          position: 'absolute', top: '2px',
                          left: valor ? '22px' : '2px',
                          width: '20px', height: '20px',
                          background: '#fff', borderRadius: '50%',
                          boxShadow: '0 1px 3px rgba(0,0,0,.3)',
                          transition: 'left .2s',
                        }}/>
                      </button>
                    ) : (
                      <input
                        type="number"
                        defaultValue={valor}
                        onBlur={e => {
                          const v = parseInt(e.target.value);
                          if (!isNaN(v) && v >= 0 && v !== valor) actualizar(s.chave, v);
                        }}
                        disabled={eSalvando}
                        style={{
                          width: '72px', textAlign: 'right', fontSize: '14px',
                          border: '1px solid var(--border)', borderRadius: '8px',
                          padding: '4px 8px', background: 'var(--input-bg)',
                          color: 'var(--text-primary)', outline: 'none',
                          opacity: eSalvando ? 0.5 : 1,
                        }}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      <div style={{ marginBottom: '28px' }}>
        <p style={{ fontSize: '11px', fontWeight: '700', color: 'var(--text-secondary)',
          textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '10px' }}>
          Gestão Rápida
        </p>
        <div style={{ background: 'var(--card)', border: '1px solid var(--border)',
          borderRadius: '16px', padding: '16px' }}>
          <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '12px' }}>
            Fornecedores com Score ≥{' '}
            <strong>{settings.find(s => s.chave === 'score_min_fornecedor_conf')?.valor ?? 75}</strong>{' '}
            são automaticamente elegíveis. Podes também atribuir manualmente.
          </p>
          <a href="/admin/fornecedores-confianca"
            style={{ fontSize: '14px', fontWeight: '600', color: 'var(--brand)',
              textDecoration: 'none' }}>
            Gerir fornecedores verificados →
          </a>
        </div>
      </div>
    </div>
  );
}
